<!-- Hidden iframe container for launching the card reader application -->
<div #iframeContainer style="display: none;"></div>

<!-- Card Reader Status Indicator -->
<div class="card-reader-status-container" 
     *ngIf="active"
     [ngClass]="'status-' + getCardReaderStatusSeverity()">
  <div class="status-content">
    <div class="status-icon-wrapper">
      <i [class]="'pi ' + getCardReaderStatusIcon() + (shouldSpinIcon() ? ' pi-spin' : '')" 
         class="status-icon"
         [ngClass]="'icon-' + getCardReaderStatusSeverity()">
      </i>
    </div>
    <div class="status-info">
      <div class="status-label">Čítačka kariet</div>
      <div class="status-message">{{ getCardReaderStatusMessage() }}</div>
    </div>
  </div>
  <button 
    *ngIf="!connecting && cardReaderStatus !== CardReaderServiceStatus.CARD_READER_CONNECTED && cardReaderStatus !== CardReaderServiceStatus.OS_NOT_SUPPORTED && cardReaderStatus !== null"
    type="button"
    pButton
    label="Znovu pripojiť"
    icon="pi pi-refresh"
    [loading]="reconnecting"
    [disabled]="reconnecting"
    (click)="reconnectCardReader()"
    class="reconnect-btn"
    [ngClass]="'btn-' + getCardReaderStatusSeverity()">
  </button>
  <button
    *ngIf="getCardReaderStatusSeverity() === 'danger'"
    type="button"
    pButton
    label="Inštalačný manuál"
    class="manual-btn"
    (click)="openManualDialog()">
  </button>
</div>

